
<template>
  <div>
    <br />
    <div class="row">
      <div class="col">
        <label for="">Client</label>
        <select class="form-select" :disabled="true" v-model="check.customer_reference">
          <option value="" default></option>
          <option v-for="(customer, index) in customers" :key="index" :value="customer.reference">
            <div class="row justify-content-between">
              <span class="col-auto">
                {{ customer.fullName }}
              </span>
              <span class="col-auto">
                {{ customer.society }}
              </span>
            </div>
          </option>
        </select>
      </div>

      <div class="col-2">
        <label for="">Montant</label>
        <input type="text" :disabled="true" v-model="check.amount" class="form-control" />
      </div>

      <div class="col-3">
        <label for="">Etat</label>
        <select class="form-select" v-model="check.status">
          <option value="Chèque en attente">Chèque en attente</option>
          <option value="Chèque payé">Chèque payé</option>
          <option value="Chèque rejeté">Chèque rejeté</option>
        </select>
      </div>

      <div class="col-3">
        <label for="">Numéro de chèque</label>
        <input type="text" v-model="check.checkNumber" :disabled="true" class="form-control" />
      </div>
    </div>

    <br />
    <div class="row">
      <div class="col-3">
        <label for=""> Nom complet (Si autre client) </label>
        <input type="text" v-model="check.fullName" class="form-control" />
      </div>

      <div class="col-3">
        <label for=""> Date échéance </label>
        <input type="date" v-model="check.deadline" class="form-control" />
      </div>

      <div class="col-3">
        <label for="">Banque</label>
        <select v-model="check.bank" class="form-select">
          <option value="" disabled>Sélectionner une banque</option>
          <option v-for="(bank, index) in banks" :key="index" :value="bank">
            {{ bank }}
          </option>
        </select>
      </div>
    </div>

    <br />
    <div class="row">
      <div class="col-12">
        <label for="">Remarques</label>
        <textarea v-model="check.remark" class="form-control" cols="30" rows="3"></textarea>
      </div>
    </div>

    <br />
    <div class="row mt-3 justify-content-between">
      <div class="col-auto"></div>
      <div class="col-auto">
        <button class="btn btn-success" @click="save(check)">
          <i class="bi bi-check-square-fill"></i> Enregistrer
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      updatedFields: {} ,
      banks: [
        "Attijariwafa Bank",
        "Banque Populaire",
        "BMCE Bank of Africa",
        "Crédit du Maroc",
        "Société Générale Maroc",
        "CIH Bank",
        "Al Barid Bank",
        "Bank of Africa",
        "UMNIA Bank",
        "CDG Capital",
      ],
    };
  },
  computed: {
    ...mapGetters("customer", {
      customers: "getAll",
    }),
    ...mapGetters("check", {
      check: "getCheck",
    }),
  },
  methods: {
    

    async save(data) {
      await this.$store.dispatch("check/update", data);
    },
  },
  beforeMount() {
    this.$store.dispatch("customer/getAll");
    this.$store.dispatch("check/show", this.$route.params.reference);
  },
};
</script>
